export const new_currency_conversion = `subscription new_currency_conversion{
    new_currency_conversion{
        transaction_code
        status
        account
        from_currency{
            currency
            name
            decimal
        }
        to_currency{
            currency
            name
            decimal
        }
        from_amount
        to_amount
        exchange_rate
        order_date
    }
}`;
